import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class ReviewRecordApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'work-review-record'
  }

}